import { Component, ViewChild, OnInit, Injectable } from "@angular/core";
import { MatButtonToggle } from "@angular/material/button-toggle";

import { MapToolboxService } from "./../../../../services/map.toolbox.service";
import { MapButtonService } from "./../../../../services/map.buttom.service";
import { PermissionsService } from "src/app/helpers/permissions.service";

@Component({
  selector: "toolbox-route",
  templateUrl: "./button-route.component.html",
  styleUrls: ["./button-route.component.scss"],
})
@Injectable({
  providedIn: "root",
})
export class ButtonRouteComponent implements OnInit {
  @ViewChild(MatButtonToggle) btnSearchGroup: MatButtonToggle;
  permissions: [];
  selected = false;

  private service: MapToolboxService;
  private mapButtonService: MapButtonService;
  constructor(
    service: MapToolboxService,
    mapButtonService: MapButtonService,
    public permissionService: PermissionsService
  ) {
    this.service = service;
    this.mapButtonService = mapButtonService;
  }
  ngOnInit(): void {
    this.permissions = this.permissionService.getPermissions();
    this.mapButtonService.currentRouteButton.subscribe((action) => {
      if (action !== this.selected) this.selected = action;
    });
  }

  onChangeValue(): void {
    if (this.selected) {
      this.mapButtonService.setRouteButton(false);
      this.service.setToolboxCommand("hide-route");
      return;
    }
    const value = !this.selected;
    this.selected = value;
    this.mapButtonService.setRouteButton(value);
    this.service.setToolboxCommand("route");
  }
}
